import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import Translator from "Languages/Utility/Translator";
import {useSelector} from "react-redux";

function SashRightClick({ data,onChangeData }) {
  const { selectedUser } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
  }));
  const [controls, setControls] = useSetState({
    sash: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  useEffect(() => {
    (async () => {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProduct: data.Id_sash,
          All: true,
          UserSelect: 0,
          KeyRequestUser: selectedUser?.Key
        };
        const response = await DrawerService.getListProfileRight(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const projectList = response.data.Value;
          const items = projectList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selectedItem = items.find((item) => item.Id === data.Id_sash)
          setControls({sash: {value: selectedItem}});
          setControls({ sash: { selectItems: items } });
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  useEffect(() =>{
    onChangeData(controls);
  },[controls]);

  return (
    <Grid item xs={12}>
      <MuiAutoComplete
        autoSelect= {true}
        options={controls.sash.selectItems}
        label={<Translator id={"sash"} />}
        value={controls.sash.value}
        id={"sash"}
        onChange={autoCompleteHandler}
      />
    </Grid>
  );
}

export default SashRightClick;
